module.exports = __webpack_public_path__ + "static/mask-4-40df0d37e6ae4790ceee4540f59bb1c1.png";